import axios from "axios";
import { push, location } from "svelte-spa-router";
import { user } from "stores.js";
import Swal from "sweetalert2";

const instance = axios.create({
  baseURL: API_URL,
  timeout: 8000,
  headers: {
    Accept: "application/json"
  }
});

let token = "";
let path = "/";
let tokenIsRefreshing = false;
let awaitingApiCalls = [];

function abort() {
  tokenIsRefreshing = false;
  awaitingApiCalls = [];
  push("/utlogging");
}

export function refreshToken() {
  return instance.post("auth/refresh").then(res => {
    user.set(res.data);
    tokenIsRefreshing = false;
  });
}

instance.interceptors.response.use(
  response => {
    // Return a successful response back to the calling service
    return response;
  },
  error => {
    const originalRequest = error.config;

    if (path === "/innlogging" || path === "/utlogging") {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (
      typeof error.response === "undefined" ||
      error.response.status === 500
    ) {
      // Something went really wrong (api down? No internet?). Try reloading:
      Swal.fire({
        title: "Kunne ikke koble til server",
        text: "Prøv en gang til eller forsøk å logg inn på nytt:",
        type: "error",
        showCancelButton: true,
        confirmButtonText: "Prøv igjen",
        cancelButtonText: "Logg inn"
      }).then(result => {
        if (result.value) {
          window.location.reload();
        } else {
          push("/utlogging");
        }
      });
    }

    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    // The refresh token call below failed, let it abort
    if (error.config.url === API_URL + "auth/refresh") {
      return new Promise((resolve, reject) => {
        reject();
      });
    }

    // Try to refresh token
    if (!tokenIsRefreshing) {
      tokenIsRefreshing = true;
      refreshToken()
        .then(() => {
          awaitingApiCalls.forEach(cb => cb());
          awaitingApiCalls = [];
        })
        .catch(err => {
          abort();
        });
    }

    // Save all other 401 requests while token is refreshing and return a promise
    // that will be resolved/rejected when token is refreshed/denied
    const retryOrigReq = new Promise((resolve, reject) => {
      awaitingApiCalls.push(() => {
        originalRequest.headers["Authorization"] = `Bearer ${token}`;

        resolve(axios(originalRequest));
      });
    });

    return retryOrigReq;
  }
);

user.subscribe(obj => {
  token = obj.access_token;

  instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
});

location.subscribe(p => {
  path = p;
});

export default instance;
